import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * Prepends the app CDN URL (environment.appCDN) to file paths.
 *
 * This pipe is used to convert stored file paths (without domain) to full URLs
 * using the configured CDN. This pattern allows flexibility in CDN configuration
 * without storing full URLs in the database.
 *
 * Usage:
 *   {{ file.filePath | staticCdn }}  → "https://cdn.example.com/path/to/file.pdf"
 *   {{ 'path/to/file.pdf' | staticCdn }}  → "https://cdn.example.com/path/to/file.pdf"
 *
 * Note: If the input is already a full URL (starts with http:// or https://),
 * it will be returned as-is.
 */
@Pipe({
  name: 'staticCdn',
  standalone: true
})
export class StaticCdnPipe implements PipeTransform {
  transform(path: string | null | undefined): string {
    if (!path) return '';

    // If already a full URL, return as-is (backwards compatibility)
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }

    // Ensure path doesn't have leading slash
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // Ensure CDN URL doesn't have trailing slash
    const cdnUrl = environment.appCDN.endsWith('/')
      ? environment.appCDN.slice(0, -1)
      : environment.appCDN;

    return `${cdnUrl}/${cleanPath}`;
  }
}
